import Content from "uxp-documentation/src/pages/uxp-api/reference-js/Modules/fs/fs.md";
import * as React from 'react';
export default {
  Content,
  React
};